"use client";
import { rgbDataURL } from "@/utils/rgbDtaurl";
import {
  Card,
  CardHeader,
  CardBody,
  Typography,
  IconButton,
  Button,
  Alert
} from "@material-tailwind/react";
import Image from "next/image";
import Link from "next/link";
import { useEffect, useState } from "react";
import { MdOutlineShoppingCart } from "react-icons/md";
import { useDispatch, useSelector, } from "react-redux";
import { toggleDrawer } from "@/GlobalRedux/Slices/drawerCart";
import { closeAlert, openAlert } from "@/GlobalRedux/Slices/alertCart";

export const ProductCard = ({ id, url, url2, title, price1, price2, onAddToCart, loading, quantity }) => {

  const dispatch = useDispatch()
  let discount = ((price2 - price1) / price2) * 100
  let result = Math.round(discount)
  const [showalert, setshowalert] = useState(false)

  const drawerOpen = () => {
    dispatch(toggleDrawer());
  }
  const showAlert = () => {
    dispatch(openAlert())
    setTimeout(() => {
      dispatch(closeAlert())
    }, 3000)
  }

  return (
    <>
      <Card className="min-w-full  sm:h-fit max-w-[8rem]  shadow-lg rounded-xl  hover:shadow-xl hover:scale-105 transition-transform duration-500 bg-darkBlack border-none">
        {/* <Link href={`/products/${title.replace(/\s+/g, "-")}-${id}`}> */}
        <Link href={`/products/${title.replace(/\s+/g, "-")}-${id}`}>
          <div className="relative">
            <IconButton
              size="sm"
              color="red"
              variant="text"
              className="absolute z-50  -top-0 right-0 sm:-top-0 sm:right-3 font-bold text-sm bg-gray-200 text-red-800 border border-gray-400 shadow-md rounded-lg px-4 py-4 hover:shadow-lg transition-all duration-300 "
            >
              {`${result}%`}
            </IconButton>
            <CardHeader
              floated={false}
              color="blue-gray"
              className="group relative rounded-b-none overflow-hidden  p-0 m-0"
            >
              <div className="relative group ">
                {/* Default Image */}
                <Image
                  src={url ? url : "/Images/Img-not-found.jpg"}
                  placeholder="blur"
                  blurDataURL={rgbDataURL(190, 190, 190)}
                  alt={title}
                  height={220}
                  width={240}
                  className="transition-opacity object-fit duration-500 opacity-100 group-hover:opacity-0 w-full  h-36 sm:h-52 "
                />
                {/* Hover Image */}
                <Image
                  src={url2 ? url2 : "/Images/Img-not-found.jpg"}
                  alt={`${title} Hover`}
                  placeholder="blur"
                  blurDataURL={rgbDataURL(190, 190, 190)}
                  height={220}
                  width={240}
                  className="absolute top-0 left-0  transition-opacity duration-500 opacity-0 group-hover:opacity-100 w-full  h-36 sm:h-52"
                />
              </div>
              <div className="absolute inset-0 h-full w-full bg-gradient-to-b from-transparent to-black opacity-20"></div>
            </CardHeader>
          </div>
        </Link>
        <CardBody className="text-gray-900 p-4">
          <Link href={`/products/${title.replace(/\s+/g, "-")}-${id}`}>
            <div className="mb-2 flex items-center justify-between">
              <Typography
                variant="h5"
                color="gray-900"
                className="text-sm font-serif  text-pureWhite truncate-title "
              >
                {title}
              </Typography>
            </div>

            <div className="flex items-center  font-serif justify-between ">
              <Typography
                color="gray-900"
                className="text-lg sm:font-bold tracking-wide
 font-serif text-pureWhite"
              >
                {`Rs.${price1}`}
              </Typography>
              <del className=" text-red-400 sm:font-semibold text-sm sm:text-sm">{`Rs.${price2}`}</del>
            </div>
          </Link>
          {/* <div className="flex sm:items-center justify-end w-full ">

            <div
              className={quantity === 0 ? "rounded-xl items-center justify-center lg:flex hidden hover:cursor-not-allowed mr-2 sm:mr-4" : "rounded-full items-center justify-center lg:flex hidden hover:cursor-pointer mr-2 sm:mr-4"}
              onClick={quantity === 0 ? undefined : drawerOpen} // Disable onClick when quantity is 0
            >
              <MdOutlineShoppingCart onClick={quantity === 0 ? undefined : onAddToCart} className="ml-4 h-8 w-8 text-pureWhite" />
            </div>

            <div
              className={quantity === 0 ? "rounded-xl items-center justify-center lg:hidden hover:cursor-not-allowed flex mr-2 sm:mr-4" : "rounded-full items-center justify-center lg:hidden hover:cursor-pointer flex mr-2 sm:mr-4"}
              onClick={quantity === 0 ? undefined : showAlert} // Disable onClick when quantity is 0
            >
              <MdOutlineShoppingCart onClick={quantity === 0 ? undefined : onAddToCart} className="ml-4 h-8 w-8 text-pureWhite" />
            </div>

          </div> */}



          <span className="lg:flex hidden" onClick={quantity==0 || undefined ?  undefined: drawerOpen} >
            <Button
            disabled={quantity==0 || undefined || loading}
              size="sm"
              // className="opacity-100  w-fit h-8 bg-secondary hover:bg-black  text-pureWhite flex gap-2 px-4"
              className="mt-2 w-full text-sm sm:text-lg  h-10 items-center bg-white flex justify-center gap-5 text-darkBlack shadow-lg hover:shadow-xl transition-all duration-300 font-serif font-bold hover:cursor-pointer"
              onClick={quantity == 0 || undefined ? undefined : onAddToCart}
               >
             {
              quantity === 0 || undefined ? 
              "Sold Out" :
             loading ? <div className="flex justify-center items-center py-10">
                <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-gray-500"></div>
              </div> :
              
                <>
                  Add To Cart <MdOutlineShoppingCart className="h-4 w-4 sm:h-6 sm:w-6 text-darkBlack " />
                </>
              }
            </Button>
          </span>
          <span className="lg:hidden  flex " onClick={quantity == 0 || undefined ? "" :showAlert}>
            <button
              size="sm"
              className="sm:mt-2 mt-2 sm:pl-2 pl-1 w-full  h-9 text-xs sm:text-lg bg-white  flex justify-center items-center rounded-lg  text-darkBlack  shadow-lg hover:shadow-xl hover:cursor-pointer transition-all duration-300 font-serif font-bold"
              onClick={quantity == 0 || undefined ? undefined :onAddToCart}
              disabled={quantity==0 || undefined || loading}
               >
              {loading ? <div className="flex justify-center items-center py-10">
                <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-gray-500"></div>
              </div> :
              quantity == 0 || undefined ? 
              "Sold Out" : 
                <>
                  Add To Carts <MdOutlineShoppingCart className="ml-4 h-6 w-6 text-darkBlack" />
                </>
              }
            </button>
          </span>

        </CardBody>

        {/* <CartDrawer openDrawer={IsCartDrawer} closeDrawer={closeDrawerCart} cartData={allCartItem} loader={isLoader} /> */}

      </Card>
      <Alert
        open={showalert}
        onClose={() => setshowalert(false)}
        className="absolute  bottom-0 capitalize"
      >
        Product Add to cart success
      </Alert>

    </>
  )
}
